import { Button } from "@/components/ui/button";
import {
	Dialog,
	DialogContent,
	DialogFooter,
	DialogTitle,
} from "@/components/ui/dialog";

function ModifySubscriptionDialog({
	showModifySubscriptionDialog,
	setShowModifySubscriptionDialog,
	onModifySubscription,
}: {
	showModifySubscriptionDialog: boolean;
	setShowModifySubscriptionDialog: (open: boolean) => void;
	onModifySubscription: () => void;
}) {
	return (
		<Dialog
			open={showModifySubscriptionDialog}
			onOpenChange={setShowModifySubscriptionDialog}
		>
			<DialogContent className="p-10">
				<DialogTitle>Modify Subscription</DialogTitle>
				<span className="web-body-b1">
					Are you sure you want to modify your subscription? Modification will
					immediately take effect.
				</span>

				<DialogFooter className="gap-4">
					<Button
						variant={"secondary"}
						className="w-full md:w-50"
						onClick={() => setShowModifySubscriptionDialog(false)}
					>
						Cancel
					</Button>
					<Button className="w-full md:w-50" onClick={onModifySubscription}>
						Confirm
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
}

export default ModifySubscriptionDialog;
